module.exports = __webpack_public_path__ + "fonts/motiva-sans-thin.8142de6.otf";